import { Component, Input } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { AppointmentDataService, ProductModel, StudyModel } from '@mmx/shared'
import { BehaviorSubject, combineLatestWith, map, Observable, of, shareReplay, Subject, switchMap, takeUntil, tap } from 'rxjs'

import { ProductDialogComponent } from '../product-dialog'

@Component({
  selector: 'mmx-procedures-card',
  templateUrl: './procedures-card.component.html',
  styleUrls: ['./procedures-card.component.scss'],
  standalone: false,
})
export class ProceduresCardComponent {
  @Input() public editable = true

  private onDestroy$ = new Subject<void>()

  displayedColumns = ['name', 'eid', 'procedureCodes']

  loading$ = new BehaviorSubject(true)

  studies$: Observable<StudyModel[]> = of(null).pipe(
    takeUntil(this.onDestroy$),
    tap(() => this.loading$.next(true)),
    switchMap(() => this.data.appointment$),
    combineLatestWith(this.data.products$),
    tap(() => this.loading$.next(false)),
    map(([appointment, products]) => {
      const studies = appointment.studies.flatMap(study => {
        return StudyModel.build(study, products)
      })

      // look for any products on the appointment not on a study
      const studyProducts = new Set(appointment.studies.flatMap(study => study.products))

      products.forEach(product => {
        if (!studyProducts.has(product.id)) {
          const fakeStudy = new StudyModel({
            products: [product.id],
            productCategories: product.categories,
          }, product)
          studies.push(fakeStudy)
        }
      })

      return studies
    }),
    shareReplay(1),
  )

  constructor(
    public data: AppointmentDataService,
    private dialog: MatDialog,
  ) {}

  public openEditProduct(study: StudyModel): void {
    const product = study.product
    this.dialog
      .open(ProductDialogComponent, {
        panelClass: 'dialog-form',
        width: '900px',
        data: {
          product,
          fromProceduresCard: true,
        },
      })
      .afterClosed()
      .subscribe((updatedProduct?: ProductModel) => {
        if (updatedProduct) {
          // pull appointments again to get updated information
          this.data.appointmentUpdated$.next()
        }
      })
  }
}
